// One power bank per Wrap in the cart (22 Sep 2026).
// The product page adds a bank with every Wrap, but the cart's + and - buttons only change the
// Wrap line. Two Wraps with one bank meant the second Wrap shipped without its bank, and Shopify
// split the Wraps into two lines whose - buttons were dead. After any cart line change, when the
// cart holds Wraps and banks in different numbers, the banks are set to match. A cart where the
// customer removed the bank, or that holds a bank on its own, is left alone.
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const WRAP_PRODUCT_ID = 9321185509633;
const BANK_VARIANT_ID = 50274622669057;
const SOURCE = 'evenfold-bank-sync';

let running = false;
let pending = false;

async function syncBanks() {
  if (running) {
    pending = true;
    return;
  }
  running = true;
  try {
    const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    let wraps = 0;
    let banks = 0;
    const bankLines = [];
    for (const item of cart.items) {
      if (item.product_id === WRAP_PRODUCT_ID) wraps += item.quantity;
      if (item.variant_id === BANK_VARIANT_ID) {
        banks += item.quantity;
        bankLines.push(item);
      }
    }
    if (!wraps || !bankLines.length || banks === wraps) return;

    // Shopify splits the banks into a free line and a full-price line when they outnumber the
    // Wraps, so every bank line is set: the first to the Wrap count, the rest to zero.
    const lines = bankLines.map((line, n) => ({ id: line.key, quantity: n === 0 ? wraps : 0 }));
    const updates = {};
    for (const line of lines) updates[line.id] = line.quantity;
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId))];
    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(new CartLinesUpdateEvent({ action: 'update', context: 'cart', lines, promise: deferred.promise }));
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections: sections.join(','), sections_url: window.location.pathname }),
    });
    const data = await response.json();
    if (!response.ok || data.errors) {
      deferred.reject(new Error(data.errors || data.description || 'Bank sync failed'));
      return;
    }
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(data),
      detail: { sections: data.sections, items: data.items, itemCount: data.item_count, source: SOURCE, didError: false },
    });
  } catch (error) {
    // Leave the cart as the customer set it.
  } finally {
    running = false;
    if (pending) {
      pending = false;
      syncBanks();
    }
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise
    ?.then((result) => {
      if (result?.detail?.source !== SOURCE) syncBanks();
    })
    .catch(() => {});
});
